import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.15, testId }) => (
  <h1 className={className} data-testid={testId}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, delay: delay + i * 0.12, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const SectionHeading = ({ eyebrow, title, intro, light = false, className = "" }) => (
  <Reveal className={className}>
    {eyebrow && <p className={`eyebrow mb-4 ${light ? "text-[var(--green-bright)]" : "text-[var(--green)]"}`}>{eyebrow}</p>}
    <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08] ${light ? "text-white" : "text-[var(--navy)]"}`}>
      {title}
    </h2>
    {intro && <p className={`mt-5 max-w-2xl text-base md:text-lg leading-relaxed ${light ? "text-slate-300" : "text-[var(--body)]"}`}>{intro}</p>}
  </Reveal>
);
